import React from "react";
import { styled } from '@mui/material/styles';
import Typography from "@mui/material/Typography";
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';

import Page from "../../layout/Page";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

const Ayuda = () => {
  const breadcrumbs = [
    { nombre: "Inicio", ruta: "/" },
    { nombre: "Preguntas frecuentes", ruta: "" }
  ];

  const preguntas = [   
    {
      pregunta: "¿Cómo puedo saber el perfil y el organismo que tengo asignado?",
      respuesta: "Podés consultarlo desde el menú (tres puntitos verticales) que se encuentra en el  margen superior derecho, opción Perfil. "
    },
    {
      pregunta: "¿Qué visualizo en la bandeja de entrada?",
      respuesta: "En la bandeja de entrada visualizás los expedientes y trámite internos que tenés en tu organismo."
    },
    {
      pregunta: "¿Cómo consulto un expediente y un trámite interno?",
      respuesta: "Desde el menú  \"Consulta de expedientes y trámites internos\" podés consultar los expedientes y los trámites internos, ya sea por su número o ingresando otros criterios de búsqueda."
    },
    {
      pregunta: "¿Cómo genero un nuevo expediente?",
      respuesta: "Si el perfil de tu usuario es Generador de expedientes, podés acceder desde el menú a través de la opción \"Nuevo expediente\" o desde la \"Bandeja de entrada\" (+ Nuevo) o desde \"Consulta de expedientes y trámites internos\" (+ Nuevo). "
    },
    {
      pregunta: "¿Se puede modificar la carátula?",
      respuesta: "Sí, desde la BANDEJA DE ENTRADA podés modificar el asunto, la temática y/o los folios de expedientes y trámites internos a través de la opción Editar que aparece en la columna Acciones, a la derecha de los datos. Siempre y cuando se trate de un expediente en soporte PAPEL y no tenga ningún movimiento registrado."
    },
    {
      pregunta: "¿Qué significa Gestionar?",
      respuesta: "Gestionar es una opción del sistema que permite realizar todas las operaciones referidas a un  expediente o trámite interno. Registrar movimientos, agregaciones, desgloses y adjuntar documentación."
    },    
    {
      pregunta: "¿Se pueden modificar los movimientos?",
      respuesta: "No, la edición de los movimientos no está permitida."
    },
    {
      pregunta: "¿Qué sucede si debo eliminar un movimiento?",
      respuesta: "El sistema permite eliminar el último movimiento."
    },
    {
      pregunta: "¿Cómo registro la recepción de un expediente o de un trámite interno?",
      respuesta: "- Podés recibir uno o más expedientes o trámites internos desde la \"Bandeja de entrada\" con la opción Recepcionar, que figura arriba a la izquierda de la grilla de resultados. Te recomendamos que ordenes los resultados de la grilla por la columna \"Recibido\" para agrupar los NO recibidos. El botón se habilita cuando se selecciona uno o más expedientes y/o trámites internos. \n- También podés recibir un expediente o trámite interno en particular, desde la acción Gestionar en la pestaña Movimientos con el botón Recepcionar de la columna acciones."
    },
    {
      pregunta: "¿Quién puede visualizar los adjuntos de un expediente o de un trámite interno?",
      respuesta: "Podés visualizar los adjuntos de un expediente o de un trámite interno cuando está en tu organismo y se encuentra recibido. También si sos un usuario del organismo que lo generó o pertenecés a un organismo superior del organismo que lo generó."
    },
    {
      pregunta: "¿Cómo realizo archivados o asigno estado a los expedientes y trámites internos?",
      respuesta: "Estas acciones las podés realizar desde la \"Bandeja de entrada\" o la \"Consulta de expedientes y trámites internos\" con las opciones Asignar estado o Archivar (según corresponda), que figuran arriba a la izquierda de la grilla de resultados. Los botones se habilitan cuando se selecciona uno o más expedientes y/o trámites internos. Si querés quitar el estado asignado a un expediente o trámite interno tenés que seleccionar el estado en blanco."
    },
    {
      pregunta: "¿Desde dónde visualizo e imprimo la carátula, la ficha o el volante?",
      respuesta: "Desde la \"Bandeja de entrada\" o la \"Consulta de expedientes y trámites internos\", a través de la acción Gestionar visualizás la información completa del expediente o trámite interno. En el margen derecho, encontrás un menú (tres puntitos verticales) mediante el cual accedés a las diferentes opciones de visualización e impresión."
    },
    {
      pregunta: "¿Quién puede visualizar e imprimir la carátula?",
      respuesta: "La visualización e impresión de la carátula sólo está disponible para los usuarios del organismo que la generó."
    },    
    {
      pregunta: "¿Puedo usar el sistema solamente en mi computadora?",
      respuesta: "También podes utilizar el sistema desde tu dispositivo móvil."
    },
    {
      pregunta: "¿Qué puedo hacer si en mi monitor no se visualizan correctamente los textos del sistema?",
      respuesta: "Podés ampliar el tamaño de tu espacio de trabajo ocultando el panel izquierdo, para ello hacé clic en el botón de menú (tres líneas horizontales) que se encuentra delante del título del sistema."
    },
    {
      pregunta: "¿Qué hago si no puedo ver el menú?",
      respuesta: "Hacé clic en el botón de menú (tres líneas horizontales) que se encuentra delante del título del sistema."
    },
    {
      pregunta: "¿Qué hago si en las preguntas frecuentes no encuentro solución a mi problema?",
      respuesta: "En ese caso comunicate con tu centro de apoyo. En la pantalla de inicio vas encontrar los números de contactos por consultas técnicas y de sistema."
    },
    {
      pregunta: "¿Cuando descargo el expediente completo se incluyen las firmas DIGITALES?",
      respuesta: "NO porque el objetivo de su armado es que puedas contar con los archivos que conforman el expediente completo de forma ordenada para poder leerlo."
    },
    {
      pregunta: "¿Cuando genero el archivo ZIP con el expediente completo se incluyen las firmas DIGITALES?",
      respuesta: "SI"
    },
    {
      pregunta: "¿Cómo puedo saber si un adjunto está firmado digitalmente?",
      respuesta: "Podés verificar si un adjunto está firmado digitalmente, desde el botón \"Verificar firmas\" que aparece a la derecha de cada adjunto, en la columna Acciones del listado de Adjuntos. También podés descargar cada uno de los Adjuntos y usar una verificación externa."
    },
    {
      pregunta: "¿Qué debo tener en cuenta al momento ADJUNTAR un documento?",
      respuesta: "El tamaño del archivo no debe ser mayor a los 10Mb. En el nombre del archivo no se deben incluir puntos. Se recomienda que los archivos PDF sean digitalizados con capacidad de búsqueda; no superen los 300 DPI y la escala de colores sea blanco y negro de 1 bit o escala de grises de 8 bits."
    },
  ]

  return (
    <Page breadcrumbs={breadcrumbs}>
      <Typography variant="titulo" paragraph>
        Preguntas frecuentes
      </Typography>
      {preguntas.map((item, indice) => {
        return (
          <Accordion key={indice}>
            <AccordionSummary
              aria-controls={"panel-content" + indice}
              id={"panel-header" + indice}
            >
              <Typography variant="cuerpo">
                <b>{item.pregunta}</b>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="cuerpo">
                {/*item.respuesta*/}
                {item.respuesta.split("\n").map((i, key) => {
                  return <div key={key}>{i}</div>;
                })}
              </Typography>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Page>
  );
};

export default Ayuda;
